import { Link, useLocation } from "wouter";
import { logout } from "../lib/webauthn-client";
import { ThemeSwitcher } from "./ThemeSwitcher";

const links: { href: string; label: string }[] = [
  { href: "/", label: "Faktúry" },
  { href: "/projection", label: "Projekcia" },
  { href: "/settings", label: "Nastavenia" },
];

export function AppNav() {
  const [location] = useLocation();
  return (
    <header class="app-nav">
      <div class="app-nav__inner">
        <Link href="/" class="app-nav__brand">
          Frondea Faktúry
        </Link>
        <nav class="app-nav__links">
          {links.map((l) => (
            <Link
              key={l.href}
              href={l.href}
              class={
                isActive(location, l.href)
                  ? "app-nav__link app-nav__link--active"
                  : "app-nav__link"
              }
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <div id="nav-page-actions" class="app-nav__actions" />
        <ThemeSwitcher compact />
        <button
          type="button"
          class="app-nav__icon-btn"
          aria-label="Odhlásiť"
          title="Odhlásiť"
          onClick={async () => {
            await logout();
            window.location.replace("/login");
          }}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
        </button>
      </div>
    </header>
  );
}

function isActive(loc: string, href: string): boolean {
  if (href === "/") return loc === "/";
  return loc === href || loc.startsWith(href + "/");
}
